export default [
  {
    value: 'AF',
    label: 'Afganistan',
  },
  {
    value: 'AL',
    label: 'Albanija',
  },
  {
    value: 'DZ',
    label: 'Alžir',
  },
  {
    value: 'AS',
    label: 'Američka Samoa',
  },
  {
    value: 'AD',
    label: 'Andora',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AG',
    label: 'Antigva i Barbuda',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AM',
    label: 'Armenija',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AU',
    label: 'Australija',
  },
  {
    value: 'AT',
    label: 'Austrija',
  },
  {
    value: 'AZ',
    label: 'Azerbejdžan',
  },
  {
    value: 'BS',
    label: 'Bahami',
  },
  {
    value: 'BH',
    label: 'Bahrein',
  },
  {
    value: 'BD',
    label: 'Bangladeš',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BY',
    label: 'Bjelorusija',
  },
  {
    value: 'BE',
    label: 'Belgija',
  },
  {
    value: 'BZ',
    label: 'Izbiti',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BM',
    label: 'Bermuda',
  },
  {
    value: 'BT',
    label: 'Butan',
  },
  {
    value: 'BO',
    label: 'Bolivija',
  },
  {
    value: 'BA',
    label: 'Bosna i Hercegovina',
  },
  {
    value: 'BW',
    label: 'Bocvana',
  },
  {
    value: 'BR',
    label: 'Brazil',
  },
  {
    value: 'IO',
    label: 'Britanski djevičanski otoci',
  },
  {
    value: 'BN',
    label: 'Brunej Darussalam',
  },
  {
    value: 'BG',
    label: 'Bugarska',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'CV',
    label: 'Cabo Verde',
  },
  {
    value: 'KH',
    label: 'Kambodža',
  },
  {
    value: 'CM',
    label: 'Kamerun',
  },
  {
    value: 'CA',
    label: 'Kanada',
  },
  {
    value: 'KY',
    label: 'Kajmanski otoci',
  },
  {
    value: 'CF',
    label: 'Centralna Afrička Republika',
  },
  {
    value: 'TD',
    label: 'Čad',
  },
  {
    value: 'CL',
    label: 'Čile',
  },
  {
    value: 'CN',
    label: 'Kina',
  },
  {
    value: 'CO',
    label: 'Kolumbija',
  },
  {
    value: 'KM',
    label: 'Komori',
  },
  {
    value: 'CG',
    label: 'Kongo',
  },
  {
    value: 'CK',
    label: 'Kuhati otoci',
  },
  {
    value: 'CR',
    label: 'Kostarika',
  },
  {
    value: 'CI',
    label: "Kôte d'Ovoire",
  },
  {
    value: 'HR',
    label: 'Hrvatska',
  },
  {
    value: 'CU',
    label: 'Kuba',
  },
  {
    value: 'CU',
    label: 'Curaçao',
  },
  {
    value: 'CY',
    label: 'Cipar',
  },
  {
    value: 'CZ',
    label: 'Češka Republika',
  },
  {
    value: 'CZ',
    label: 'Demokratska narodna Republika Koreja',
  },
  {
    value: 'CD',
    label: 'Demokratska Republika Kongo',
  },
  {
    value: 'DK',
    label: 'Danska',
  },
  {
    value: 'DK',
    label: 'Diego Garcia',
  },
  {
    value: 'DJ',
    label: 'Džibuti',
  },
  {
    value: 'DM',
    label: 'Dominika',
  },
  {
    value: 'DO',
    label: 'Dominikanska Republika',
  },
  {
    value: 'EC',
    label: 'Ekvador',
  },
  {
    value: 'EG',
    label: 'Egipat',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'GQ',
    label: 'Ekvatorijalna Gvineja',
  },
  {
    value: 'ER',
    label: 'Eritreja',
  },
  {
    value: 'EE',
    label: 'Estonija',
  },
  {
    value: 'EE',
    label: 'Eswatini',
  },
  {
    value: 'ET',
    label: 'Etiopija',
  },
  {
    value: 'FK',
    label: 'Falklandski otoci',
  },
  {
    value: 'FO',
    label: 'Farski otoci',
  },
  {
    value: 'FJ',
    label: 'Fidži',
  },
  {
    value: 'FI',
    label: 'Finska',
  },
  {
    value: 'FR',
    label: 'Francuska',
  },
  {
    value: 'FR',
    label: 'Francuski odjeli i teritoriji u Indijskom oceanu',
  },
  {
    value: 'GF',
    label: 'Francuska Gvajana',
  },
  {
    value: 'PF',
    label: 'Francuska Polinezija',
  },
  {
    value: 'GA',
    label: 'Gabon',
  },
  {
    value: 'GM',
    label: 'Gambija',
  },
  {
    value: 'GE',
    label: 'Gruzija',
  },
  {
    value: 'DE',
    label: 'Njemačka',
  },
  {
    value: 'GH',
    label: 'Gana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GR',
    label: 'Grčka',
  },
  {
    value: 'GL',
    label: 'Grenland',
  },
  {
    value: 'GD',
    label: 'Grenada',
  },
  {
    value: 'GP',
    label: 'Guadeloupa',
  },
  {
    value: 'GU',
    label: 'Gumba',
  },
  {
    value: 'GT',
    label: 'Gvatemala',
  },
  {
    value: 'GG',
    label: 'Gvineja',
  },
  {
    value: 'GN',
    label: 'Zamor',
  },
  {
    value: 'GY',
    label: 'Gvajana',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
  },
  {
    value: 'HU',
    label: 'Mađarska',
  },
  {
    value: 'IS',
    label: 'Island',
  },
  {
    value: 'IN',
    label: 'Indija',
  },
  {
    value: 'ID',
    label: 'Indonezija',
  },
  {
    value: 'IR',
    label: 'Iran',
  },
  {
    value: 'IQ',
    label: 'Irak',
  },
  {
    value: 'IE',
    label: 'Irska',
  },
  {
    value: 'IL',
    label: 'Izrael',
  },
  {
    value: 'IT',
    label: 'Italija',
  },
  {
    value: 'JM',
    label: 'Jamajka',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'JO',
    label: 'Jordan',
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
  },
  {
    value: 'KE',
    label: 'Kenija',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KR',
    label: 'Koreja',
  },
  {
    value: 'XK',
    label: 'Kosov',
  },
  {
    value: 'KW',
    label: 'Kuvajt',
  },
  {
    value: 'KG',
    label: 'Kirgijski',
  },
  {
    value: 'LA',
    label: 'Lao narodna demokratska republika',
  },
  {
    value: 'LV',
    label: 'Latvija',
  },
  {
    value: 'LB',
    label: 'Libanon',
  },
  {
    value: 'LS',
    label: 'Lesoto',
  },
  {
    value: 'LR',
    label: 'Liberija',
  },
  {
    value: 'LY',
    label: 'Libija',
  },
  {
    value: 'LI',
    label: 'Lihtenštajn',
  },
  {
    value: 'LT',
    label: 'Litva',
  },
  {
    value: 'LU',
    label: 'Luksemburg',
  },
  {
    value: 'MO',
    label: 'Makao',
  },
  {
    value: 'MG',
    label: 'Madagaskar',
  },
  {
    value: 'MW',
    label: 'Malavi',
  },
  {
    value: 'MY',
    label: 'Malezija',
  },
  {
    value: 'MV',
    label: 'Maldivi',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MH',
    label: 'Marshall Islands',
  },
  {
    value: 'MQ',
    label: 'Martikin',
  },
  {
    value: 'MR',
    label: 'Mauritanija',
  },
  {
    value: 'MU',
    label: 'Mauricijus',
  },
  {
    value: 'MX',
    label: 'Meksiko',
  },
  {
    value: 'FM',
    label: 'Mikronezija',
  },
  {
    value: 'MD',
    label: 'Moldavija',
  },
  {
    value: 'MC',
    label: 'Monako',
  },
  {
    value: 'MN',
    label: 'Mongolija',
  },
  {
    value: 'ME',
    label: 'Crna Gora',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MA',
    label: 'Maroko',
  },
  {
    value: 'MZ',
    label: 'Mozambik',
  },
  {
    value: 'MM',
    label: 'Mjanmar',
  },
  {
    value: 'NA',
    label: 'Namibija',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'NL',
    label: 'Nizozemska',
  },
  {
    value: 'NC',
    label: 'nova Kaledonija',
  },
  {
    value: 'NZ',
    label: 'Novi Zeland',
  },
  {
    value: 'NI',
    label: 'Nikaragva',
  },
  {
    value: 'NE',
    label: 'Niger',
  },
  {
    value: 'NG',
    label: 'Nigerija',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NF',
    label: 'Otok Norfolk',
  },
  {
    value: 'NF',
    label: 'Sjeverna Makedonija',
  },
  {
    value: 'MP',
    label: 'Sjeverni Mariana Otoci',
  },
  {
    value: 'NO',
    label: 'Norveška',
  },
  {
    value: 'OM',
    label: 'Oman',
  },
  {
    value: 'PK',
    label: 'Pakistan',
  },
  {
    value: 'PW',
    label: 'Palau',
  },
  {
    value: 'PA',
    label: 'Panama',
  },
  {
    value: 'PG',
    label: 'Papua Nova Gvineja',
  },
  {
    value: 'PY',
    label: 'Paragvaj',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PH',
    label: 'Filipini',
  },
  {
    value: 'PL',
    label: 'Poljska',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PR',
    label: 'Portoriko',
  },
  {
    value: 'QA',
    label: 'Katar',
  },
  {
    value: 'RO',
    label: 'Rumunjska',
  },
  {
    value: 'RU',
    label: 'Ruska Federacija',
  },
  {
    value: 'RW',
    label: 'Ruanda',
  },
  {
    value: 'SH',
    label: 'Sveta Helena, Uzašašće i Tristan da Cunha',
  },
  {
    value: 'KN',
    label: 'Sveti Kitts i Nevis',
  },
  {
    value: 'LC',
    label: 'Sveta Lucia',
  },
  {
    value: 'PM',
    label: 'Saint Pierre i Miquelon',
  },
  {
    value: 'VC',
    label: 'Sveti Vincent i Grenadine',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'ST',
    label: 'Sao Tome i Principe',
  },
  {
    value: 'SA',
    label: 'Saudijska Arabija',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'RS',
    label: 'Srbija',
  },
  {
    value: 'SC',
    label: 'Sejšeli',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
  },
  {
    value: 'SG',
    label: 'Singapur',
  },
  {
    value: 'SG',
    label: 'Sint Maarten',
  },
  {
    value: 'SK',
    label: 'Slovačka',
  },
  {
    value: 'SI',
    label: 'Slovenija',
  },
  {
    value: 'SB',
    label: 'Salomonski otoci',
  },
  {
    value: 'SO',
    label: 'Somalija',
  },
  {
    value: 'ZA',
    label: 'Južna Afrika',
  },
  {
    value: 'SS',
    label: 'Južni Sudan',
  },
  {
    value: 'ES',
    label: 'Španjolska',
  },
  {
    value: 'LK',
    label: 'Šri Lanka',
  },
  {
    value: 'SD',
    label: 'Sudan',
  },
  {
    value: 'SR',
    label: 'Surominam',
  },
  {
    value: 'SE',
    label: 'Švedska',
  },
  {
    value: 'CH',
    label: 'Švicarska',
  },
  {
    value: 'SY',
    label: 'Sirijska Arapska republika',
  },
  {
    value: 'TW',
    label: 'Tajvan',
  },
  {
    value: 'TJ',
    label: 'Tadžikistan',
  },
  {
    value: 'TZ',
    label: 'Tanzanija',
  },
  {
    value: 'TH',
    label: 'Tajland',
  },
  {
    value: 'TL',
    label: 'Timor-Leste',
  },
  {
    value: 'TG',
    label: 'Togo Republika',
  },
  {
    value: 'TK',
    label: 'Tokelau',
  },
  {
    value: 'TO',
    label: 'Laka dvokolica',
  },
  {
    value: 'TT',
    label: 'Trinidad i Tobago',
  },
  {
    value: 'TN',
    label: 'Tunis',
  },
  {
    value: 'TR',
    label: 'Republika Turska',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
  },
  {
    value: 'TC',
    label: 'Turci i Caicos',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UA',
    label: 'Ukrajina',
  },
  {
    value: 'AE',
    label: 'Ujedinjeni Arapski Emirati',
  },
  {
    value: 'GB',
    label: 'Ujedinjeno Kraljevstvo',
  },
  {
    value: 'US',
    label: 'Ujedinjene države',
  },
  {
    value: 'US',
    label: 'Djevičanski otoci Sjedinjenih Država',
  },
  {
    value: 'UY',
    label: 'Urugvaj',
  },
  {
    value: 'UZ',
    label: 'Uzbekistan',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'VE',
    label: 'Venezuela',
  },
  {
    value: 'VN',
    label: 'Viet',
  },
  {
    value: 'WF',
    label: 'Wallis i futuna',
  },
  {
    value: 'YE',
    label: 'Jemen',
  },
  {
    value: 'ZM',
    label: 'Zambija',
  },
  {
    value: 'ZM',
    label: 'Zimbabve',
  },
];
